import { createGlobalStyle } from 'styled-components'
export const GlobalStyles = createGlobalStyle`
  body {
    transition: all 0.2s ease-in,;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-family: 'Roboto', sans-serif;
  }  

  .custom-swal-wide {
  width: 80% !important;
  max-width: none !important;
}
`

export const lightTheme = {
  body: '#f5f6f8',
  text: '#333333',
  colorButtonCircle: '#404C77',
  boxShadow: '0px 2px 3px rgba(4, 4, 7, 0.1)',
  backgroundButton: '#FFFFFF',
  border: '1px solid #e6e6e6',
  colorSublink: '#6A788E',
  primary: '#68AB44',
  primary_scale1: 'rgba(104, 171, 68, 0.6)',
  primary_scale2: 'rgba(104, 171, 68, 0.2)',
  menu_category: 'rgb(138, 152, 172)',
  menu_link_active: '#FFF',
  hover_color: '#eaedf1',
  success: '#68AB44',
  info: '#DBF1FF',
  warning: '#f1c40f',
  danger: '#A93D27',
  secondary: '#E8765D',
  purple: '#5F1D11',
  Perdido: '#A93D27',
  Ganado: '#68AB44',
  Entregado: '#68AB44',
  Terminado: '#68AB44',
  Creado: '#f1c40f',
  Facturado: '#5F1D11',
  Pagado: '#68AB44',
  'Avance de obra': '#68AB44',
  Facturar: '#E8765D',
  Cancelado: '#A93D27',
  'En Ejecución': '#68AB44',

}
export const darkTheme = {
  body: '#2A2A2A',
  text: '#fff',
  colorButtonCircle: '#fff',
  boxShadow: '0px 2px 3px #1a1a2f',
  backgroundButton: '#2A2B43',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  colorSublink: '#fff',
  primary: '#68AB44',
  primary_scale1: 'rgba(104, 171, 68, 0.6)',
  primary_scale2: 'rgba(104, 171, 68, 0.2)',
  menu_category: 'rgb(138, 152, 172)',
  menu_link_active: '#FFF',
  hover_color: '#2e2e4a',
  success: '#68AB44',
  info: '#DBF1FF',
  warning: '#f1c40f',
  danger: '#A93D27',
  secondary: '#E8765D',
  purple: '#5F1D11',
  Perdido: '#A93D27',
  Ganado: '#68AB44',
  Entregado: '#68AB44',
  Terminado: '#68AB44',
  Creado: '#f1c40f',
  Facturado: '#5F1D11',
  Pagado: '#68AB44',
  'Avance de obra': '#68AB44',
  Facturar: '#E8765D',
  Cancelado: '#A93D27',
  'En Ejecución': '#68AB44',
}
